// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.projectsContainer {
  display: flex;
  flex-direction: row;
  margin-top: 5rem;
  background-color: rgb(101, 109, 112, 0.3);
  height: 60rem;
  max-width: fit-content;
  box-shadow: inset 0px 0px 7px rgba(0, 0, 0, 0.9);
  border-radius: 2rem;
  padding-left: 2rem;
  padding-right: 2rem;
  justify-content: center;
}

p {
  padding-top: 1rem;
  color: azure;
  font-size: large;
}
.projectsHeader {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.wrenchLogo {
  color: rgb(34 211 238);
  font-size: 4rem;
  margin-top: 1rem;
  margin-left: 1rem;
}

@media screen and (max-width: 767px) {
  .projects {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .projectsHeader {
    align-self: center;
  }

  .projectsContainer {
    width: 90%;
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
    margin-left: 1rem;
  }
  .customCard {
    align-self: center;
    width: 90%;
    margin-left: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/Projects.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;EACnB;EACA;IAEE,kBAAkB;IAClB,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".projects {\r\n  margin-top: 2rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.projectsContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin-top: 5rem;\r\n  background-color: rgb(101, 109, 112, 0.3);\r\n  height: 60rem;\r\n  max-width: fit-content;\r\n  box-shadow: inset 0px 0px 7px rgba(0, 0, 0, 0.9);\r\n  border-radius: 2rem;\r\n  padding-left: 2rem;\r\n  padding-right: 2rem;\r\n  justify-content: center;\r\n}\r\n\r\np {\r\n  padding-top: 1rem;\r\n  color: azure;\r\n  font-size: large;\r\n}\r\n.projectsHeader {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.wrenchLogo {\r\n  color: rgb(34 211 238);\r\n  font-size: 4rem;\r\n  margin-top: 1rem;\r\n  margin-left: 1rem;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .projects {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  .projectsHeader {\r\n    align-self: center;\r\n  }\r\n\r\n  .projectsContainer {\r\n    width: 90%;\r\n    height: fit-content;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0;\r\n    margin-left: 1rem;\r\n  }\r\n  .customCard {\r\n    align-self: center;\r\n    align-self: center;\r\n    width: 90%;\r\n    margin-left: 1.2rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
